import { Link, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { getCourseData } from '../../courseData';
import SingleCourse from '../../components/SingleCourse/SingleCourse';
import './CoursePage.css'


const CoursePage = () => {
  type CoursePageProps = {
    id: number,
    name: string,
    description: string,
    price: number,
    image: { Location: string },
    instructor: { name: string };
    details: string,
    lessons: { }
    updatedAt: string;
  }
  type LessonProps = {
    title: string,
    content: string,
    video: {Location: string}
  }
  const params = useParams();
  const [course, setCourse] = useState<CoursePageProps | any>([]);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  let num = 0;
  let numText = "";
  useEffect(() => { 
    (async () => setCourse(await getCourseData()))();
  }, []);

  const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    
    const id = target.id;
    if (id==="0") {
      numText = "zero"
      setIsExpanded(!isExpanded);

    }
    if (id==="1") {
      numText = "one"

    }
    if (id==="2") {
      numText = "two"
    }
    if (id==="3") {
      numText = "three"

    }
  }
  
  return (
    <div>
      {course.map((course: { id: number; slug: string; name: string; description: string; category: string; price: number; image: { Location: string }; instructor: { name: string }; details: string; updatedAt: string; lessons: [LessonProps]; }) => {
          if (course.name === params.courseName) {
            return (
              <div>
                <SingleCourse
                id={course.id}
                key={course.id}
                name={course.name}
                description={course.description}
                price={course.price}
                category={course.category}
                image={course.image?.Location}
                details={course.details}
                instructor={course.instructor}
                updatedAt={course.updatedAt}
                />
                {course.lessons && <h2 className='LessonTitle'>{course.lessons.length} Lessons</h2>}
                {course.lessons.map((lesson: LessonProps) => {
                  return (
                    <div>
                      <ul>
                        <li className='Lessons'>
                          <div className='Lesson-Title' id={`${num}`}><span>{num += 1}</span> {lesson.title}</div>
                          <div className={isExpanded ?`${numText}-expanded`: "Lesson-Content"}>
                            <div className='Cont'>
                              <h4 className='Cont-Title'>Content</h4>
                              <p >{lesson.content}</p>
                    
                            </div>
                            
                            {lesson.video?.Location ?
                              <Link to={`/courses/lessons/${lesson.title}`} ><p className="Lesson-Video">Watch Lesson</p></Link> :
                              <p className="Lesson-Video">No Lesson Videos Added Yet</p>
                            }
                          </div>
                          
                          
                        </li>
                      </ul>
                      
                      
                    </div>
                    
                  )
                  
                })}
              </div>
              
              
            )
          }
        
        return null;
        
        
            
      })}
    </div>
  )
}

export default CoursePage